<template>
    <div class="search-result-list record-choose-list">
        <virtual-list id="RecordSearchList" class="overflow-y-scroll scroll-touch"
            :data-key="'id'"
            :data-sources="resultList"
            :data-component="itemComponent"
            :estimate-size="50"
            :item-class="'com-record-item-w88'" />
    </div>
</template>

<script>
import ChooseRecordChooseItem from '../../components/ChooseRecordChooseItem.vue'
export default {
    name: 'RecordSearchList',
    props: {
        resultList: {
            type: Array,
            default() { return [] }
        }
    },
    data() {
        return {
            itemComponent: ChooseRecordChooseItem
        }
    },
    mounted() {
        setTimeout(() => {
            this.initDom();
        }, 20);
    },
    methods: {
        initDom() {
            var barDom = document.getElementsByClassName('record-choose-bar')[0],
                titleDom = document.getElementsByClassName('layout-rl-title')[0],
                listDom = document.getElementById('RecordSearchList');
            if(listDom && barDom && titleDom) {
                listDom.style.height = (innerHeight - barDom.clientHeight - titleDom.clientHeight+40) + 'px';
            }
        },
    }
}
</script>